<div class="flex flex-wrap gap-3">
  @for (option of requestOptions; track option.type) {
    <button
      class="flex items-center gap-2 py-2 px-3 rounded-lg border border-gray-300 font-semibold cursor-pointer hover:text-primary hover:border-primary"
      (click)="onRequestOptionClick(option)"
      [attr.aria-disabled]="isDisabledType(option.type) || option.disabled || (isRegionUnavailable(option) && !option.isChecked) || null"
      [attr.aria-invalid]="isRegionError(option) || null"
      [ngClass]="{
        'text-primary border-primary': option.isChecked && !isRegionError(option),
        'region-error text-red-600 border-red-600': isRegionError(option),
        'pointer-events-none opacity-50':
          isDisabledType(option.type) || option.disabled || (isRegionUnavailable(option) && !option.isChecked),
      }"
    >
      <rkt-icon class="text-xl" [name]="option.iconName"></rkt-icon>
      <span class="text-black">{{ option.label }}</span>
      @if (unavailableReasons()[option.type]; as reason) {
        <span class="text-xs font-normal text-gray-600">{{ reason }}</span>
      }
      <rkt-icon class="text-xl" [name]="option.isChecked ? 'checkbox-on' : 'checkbox-off'"></rkt-icon>
    </button>
  }
</div>
